(() => {
  const slots = document.querySelectorAll('[data-ausmed-pdp-accessories-back]');
  if (!slots.length) return;

  const params = new URLSearchParams(window.location.search || '');
  const rawFrom = params.get('from');
  if (!rawFrom) return;

  // Support handle, /products/handle, or full URL.
  let handle = rawFrom;
  try {
    handle = decodeURIComponent(handle);
  } catch {
    // noop
  }
  handle = handle.split('?')[0].split('#')[0].trim();
  const productsIdx = handle.lastIndexOf('/products/');
  if (productsIdx !== -1) handle = handle.slice(productsIdx + '/products/'.length);
  if (handle.includes('/')) handle = handle.split('/').pop();
  handle = handle.trim();
  if (!handle) return;

  const originUrl = `/products/${handle}`;

  function render({ title, imageUrl }) {
    for (const slot of slots) {
      // Don't render if already present (hot reload / partial rerenders).
      if (slot.querySelector('.ausmed-pdp-accessories__back')) continue;

      const a = document.createElement('a');
      a.className = 'ausmed-pdp-accessories__back';
      a.href = originUrl;

      const media = document.createElement('span');
      media.className = 'ausmed-pdp-accessories__back-media';
      media.setAttribute('aria-hidden', 'true');

      if (imageUrl) {
        const img = document.createElement('img');
        img.className = 'ausmed-pdp-accessories__back-image';
        img.alt = '';
        img.loading = 'lazy';
        img.src = imageUrl;
        media.appendChild(img);
      }

      const text = document.createElement('span');
      text.className = 'ausmed-pdp-accessories__back-text';

      const kicker = document.createElement('span');
      kicker.className = 'ausmed-pdp-accessories__back-kicker';
      kicker.textContent = 'Back to';

      const t = document.createElement('span');
      t.className = 'ausmed-pdp-accessories__back-title';
      t.textContent = title || handle;

      text.appendChild(kicker);
      text.appendChild(t);
      a.appendChild(media);
      a.appendChild(text);

      slot.appendChild(a);
    }
  }

  function ensureAccessoriesList(fromHandle) {
    const section = document.querySelector('.ausmed-pdp-accessories');
    if (!section) return;

    const existingList = section.querySelector('.ausmed-pdp-accessories__list');
    if (existingList && existingList.children.length > 0) return;

    fetch(originUrl, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sourceList = doc.querySelector('.ausmed-pdp-accessories .ausmed-pdp-accessories__list');
        if (!sourceList) return;

        const cloned = sourceList.cloneNode(true);

        const currentPath = window.location.pathname;
        for (const item of Array.from(cloned.querySelectorAll('a[href]'))) {
          try {
            const url = new URL(item.getAttribute('href'), window.location.origin);
            // Remove the current accessory product from the list.
            if (url.pathname === currentPath) {
              item.closest('li')?.remove();
              continue;
            }
            // Preserve original `from` across accessory navigation.
            url.searchParams.set('from', fromHandle);
            item.setAttribute('href', url.pathname + '?' + url.searchParams.toString());
          } catch {
            // ignore malformed hrefs
          }
        }

        // Insert list after heading if present, otherwise append.
        const heading = section.querySelector('.ausmed-pdp-accessories__heading');
        if (heading && heading.parentNode) {
          heading.insertAdjacentElement('afterend', cloned);
        } else {
          section.appendChild(cloned);
        }
      })
      .catch(() => {});
  }

  // Fetch the origin product data for title + image.
  fetch(`${originUrl}.js`, { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (!data) return render({ title: handle, imageUrl: '' });
      render({ title: data.title || handle, imageUrl: data.featured_image || '' });
    })
    .catch(() => render({ title: handle, imageUrl: '' }));

  // If the accessories section is present but hidden (no items for this product),
  // reveal it so the "Back to" card can be used as navigation.
  for (const slot of slots) {
    const section = slot.closest('.ausmed-pdp-accessories');
    if (section && section.hasAttribute('hidden')) {
      section.removeAttribute('hidden');
    }
  }

  // If the accessory PDP doesn't have the accessories list configured, copy it
  // from the origin product page and remove the current accessory item.
  ensureAccessoriesList(handle);
})();

